export default "__VITE_ASSET__gwyeaQhyzc4ijaIXHt$MIw__";